import { Box, Typography } from '@mui/material';
import React from 'react';
import { VyDatePicker } from '../../../../components/new-design/date-picker/VyDatePicker';
import { VyTableToolbar } from '../../../../components/new-design/table/vy-table-toolbar/vy-table-toolbar';
import {
  reportDatePickerSlotProps,
  reportSearchInputSx,
} from '../../reports-components/report-toolbar-styles';

type UnchargedUsageReportToolbarProps = {
  selectedMonth: Date | null;
  onMonthChange: (date: Date | null) => void;
  customerAlias: string;
  onCustomerAliasChange: (value: string) => void;
};

export const UnchargedUsageReportToolbar: React.FC<UnchargedUsageReportToolbarProps> = ({
  selectedMonth,
  onMonthChange,
  customerAlias,
  onCustomerAliasChange,
}) => {
  return (
    <Box
      sx={{
        px: 2,
        pb: 2,
        display: "flex",
        alignItems: "flex-end",
        flexWrap: "wrap",
        gap: 2
      }}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          flexShrink: 0
        }}>
        <Typography variant="caption" sx={{
          mb: 0.5
        }}>
          Month
        </Typography>
        <VyDatePicker
          value={selectedMonth}
          onChange={onMonthChange}
          views={['month', 'year']}
          openTo="month"
          format="MMM YYYY"
          disableManualInput
          slotProps={reportDatePickerSlotProps}
        />
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          flex: '1 1 200px',
          maxWidth: 300,
          minWidth: 160
        }}>
        <Typography variant="caption" sx={{
          mb: 0.5
        }}>
          Customer
        </Typography>
        <VyTableToolbar.SearchInput
          showLabel={false}
          onChange={(event) => onCustomerAliasChange(event.target.value)}
          defaultValue={customerAlias}
          placeholder="Filter by customer..."
          sx={reportSearchInputSx}
        />
      </Box>
    </Box>
  );
};
